import { format } from "date-fns";
import { parseISO } from "date-fns/fp";
import { ja } from "date-fns/locale";

const getDateTimeForDisplayOnEventCard = (
    start_time: string,
    finish_time: string
) => {
    const start = format(parseISO(start_time), "M/dd(E) HH:mm", {
        locale: ja,
    });
    const finish = format(parseISO(finish_time), "HH:mm", {
        locale: ja,
    });

    return `${start}~${finish}`;
};

export default getDateTimeForDisplayOnEventCard;
